import { render, staticRenderFns } from "./UpdateStatusNfe.vue?vue&type=template&id=4bbbd349&scoped=true"
import script from "./UpdateStatusNfe.vue?vue&type=script&lang=js"
export * from "./UpdateStatusNfe.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatusNfe.vue?vue&type=style&index=0&id=4bbbd349&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbd349",
  null
  
)

export default component.exports